module.exports = __webpack_public_path__ + "static/media/chase.5be95440.png";